module.exports = __webpack_public_path__ + "cachable/fonts/fa-solid-900.149d83e172c5a4b855ac26fcf41f3d74.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-solid-900.ttf
// module id = 1188
// module chunks = 0